export enum SecuritySolution {
  StaticCode = 'StaticCode',
  KeyCard = 'KeyCard',
  Dynamic = 'Dynamic',
  None = 'None',
}
